function generateBlobUrl(blob: Blob): string {
    return window.URL.createObjectURL(blob);
}

function releaseBlobUrl(url: string): void {
    window.URL.revokeObjectURL(url);
}

export function openBlob(blob: Blob, fn: (href: string) => void): void {
    const href = generateBlobUrl(blob);

    try {
        fn(href);
    } finally {
        releaseBlobUrl(href);
    }
}

export async function downloadBlob(blobFn: () => Promise<Blob>): Promise<void> {
    // open the window before first await, so it is not blocked by browsers/ad-blockers:
    const w = window.open();
    if (!w) {
        return;
    }

    const blob = await blobFn();
    openBlob(blob, href => w.location = href);
}